module.exports = __webpack_public_path__ + "img/ic_mlg_coupon2.0c0894fd.svg";